/**
 * RS / Projects — puzzle assembly, one-shot.
 *
 * Each cell starts shifted along its own direction (inline --rs-puzzle-out,
 * computed server-side). The first time a cell enters the viewport it slides
 * into place and is unobserved — the animation never replays. Reduced motion:
 * everything is simply visible.
 */
class RsProjects extends HTMLElement {
  #observer = null;

  connectedCallback() {
    if (this.dataset.animate !== 'true') return;

    const cells = this.querySelectorAll('[data-rs-cell]');
    if (cells.length === 0) return;

    this.classList.add('rs-projects--animated');

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-in');
          this.#observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );
    for (const cell of cells) this.#observer.observe(cell);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('rs-projects')) {
  customElements.define('rs-projects', RsProjects);
}
